import type { TFunction } from 'i18next';

/** Internal value stored in state — never shown directly in UI */
export const FEED_SOURCE_PLACEHOLDER = 'Select your feed source';

/** Internal value when screen share is selected */
export const FEED_SCREEN_SHARE = 'Screen Share';

export function isFeedPlaceholder(value: string): boolean {
  return value === FEED_SOURCE_PLACEHOLDER;
}

export function displayFeedSourceLabel(
  value: string,
  t: TFunction<'RealtimeExam'>
): string {
  if (isFeedPlaceholder(value)) {
    return t('feedSelector.selectPlaceholder');
  }
  if (value === FEED_SCREEN_SHARE) {
    return t('feedSelector.screenShare');
  }
  return value;
}
